module.exports = __webpack_public_path__ + "img/avatar4.bad46ae4.png";